import { Grid, Table, TableBody, TableCell, TableHead, TableRow, Button } from '@mui/material';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { UserItem } from '../../Users/UserItem';
import { setCurrentLocation } from '../../../app/cookies';
import { getUsersByAccountTC, UserType } from '../../Users/users-reducer';
import { AppRootState, useAppDispatch } from '../../../app/store';
import { AccountType } from '../accounts-reducer';

export const NewAccountUsersList = (props: UsersListPropsType) => {
  const dispatch = useAppDispatch()
  const isLoggedIn = useSelector<AppRootState, boolean>(state => state.auth.isLoggedIn)
  const users = useSelector<AppRootState, Array<UserType>>(state => state.newAccount.account.users)

  useEffect(() => {
  //  dispatch(getUsersByAccountTC({ accountId: props.account.id }))
  }, [isLoggedIn])

  return (
    <>
      <Table style={{ borderTop: '1px solid rgba(169, 169, 169, 1)', borderLeft: '1px solid rgba(169, 169, 169, 1)', borderRight: '0.6px solid rgba(169, 169, 169, 1)' }}>
        <TableHead style={{ backgroundColor: 'rgba(25,118,210,0.5)' }}>
          <TableRow>
            <TableCell style={{ textAlign: 'center' }}>
              #ID
            </TableCell>
            <TableCell >
              FirstName
            </TableCell>
            <TableCell style={{ textAlign: 'center', minWidth: '75px' }}>
              LastName
              <span style={{ cursor: 'pointer', marginLeft: '5px' }}></span>
            </TableCell>
            {/* <TableCell style={{ textAlign: 'center', minWidth: '65px' }}>
              Description
              <span style={{ cursor: 'pointer', marginLeft: '5px' }}></span>
            </TableCell> */}
            <TableCell style={{ textAlign: 'center', minWidth: '154px' }}>
              Roles
            </TableCell>
            <TableCell style={{ textAlign: 'center', minWidth: '154px' }}>
              Projects
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user) => (
            <UserItem user={user} />
          ))}
        </TableBody>
      </Table>
      <Grid container style={{ paddingBottom: '50px' }} spacing={3} alignItems="center">
        <Grid item xl={6} md={6} xs={6}>
        </Grid>
        <Grid item xl={6} md={6} xs={6} >
          <Button onClick={props.addNewUser} className='addItemButton' style={{ float: 'right', marginTop: '40px' }} 
          startIcon={<PersonAddIcon style={{ color: 'grey' }} fontSize='medium' />}>
            Add new User
          </Button>
        </Grid>
      </Grid>
    </>
  )
}

export type UsersListPropsType = {
  account: AccountType
  addNewUser: () => void
}
